<template>
  <div style="display: flex; background-color:gray; width:100%; height:100%">
    <div style="display: block;align-items:normal; width:100%; height:100%">
      <v-row style="background: #b8b8c8;margin: 5px;">
        <v-col md="1" sm="12" xs="12">
          <v-btn icon @click="kanbanView = !kanbanView" >
            <v-icon>list_alt</v-icon>
          </v-btn>
        </v-col>
        <v-col v-if="kanbanView" md="2" sm="12" xs="12">
          <v-btn
              outlined
              text
              color="black"
              class="task-open"
              @click="$refs.taskForm.openDialog()">
            {{ $t('buttons:create-specific', {specific: $t('common:task')}) }}
          </v-btn>
        </v-col>
        <v-col v-if="kanbanView" md="2" sm="12" xs="12">
          <v-text-field v-model="search" outlined clearable :label="$t('components:common.search')" />
        </v-col>
        <v-col v-if="kanbanView" md="3" sm="12" xs="12">
          <v-autocomplete
            v-if="isAdmin"
            :items="customers"
            v-model="currentCompany"
            clearable
            outlined
            color="primary"
            item-text="translatedName"
            item-value="id"
            :label="$t('common:customer')"
            />
        </v-col>
        <v-col v-if="kanbanView" md="3" sm="12" xs="12">
          <v-autocomplete
              :items="users"
              v-model="userId"
              clearable
              outlined
              color="primary"
              item-text="name"
              item-value="id"
              :label="$t('common:user_plural')"
          />
        </v-col>
      </v-row>

      <v-row  v-if="couldBeShown && kanbanView" class="issue-board-row" style="margin:5px">
        <v-col v-for="(value, index) in  header" :key="index" cols="12" md="2" lg="2" sm="2" class="draggable-col" style="max-width:12%;">
          <div class="tab-header">{{value.label}}</div>
          <div class="draggable-area">
            <draggable :class="'list-group' + ` ${value.code}` " v-model="tasks[value.code]" @end="movedItem" group="task-type"  >
              <v-card
                  class="mx-auto list-group-item"
                  max-width="344"
                  outlined
                  v-for="(element, index) in tasks[value.code]"
                  :key="element.name + index"
                  style="background:#0077ff"
              >
                <v-list-item three-line style="background: #0077ff">
                  <v-list-item-content>
                    <div class="text-overline mb-4">
                      {{ $t('enums:book/task.categoryTask.' + element.category) }}
                    </div>
                    <v-list-item-title class="text-h5 mb-1">
                      {{ element.name }}
                    </v-list-item-title>
                    <v-list-item-subtitle>{{ element.description }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-card-actions>
                  <v-btn
                      outlined
                      rounded
                      text
                      color="black"
                      @click="$refs.taskReview.openDialog(element)"
                  >
                    {{ $t('buttons:open-specific', {specific: $t('common:task')}) }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </draggable>
          </div>
        </v-col>
      </v-row>
      <v-row v-if="!kanbanView">
        <v-col cols="12">
          <DataTablePaginated
            ref="table"
            class="ma-1"
            :headers="headers"
            icon="visibility"
            :iconTooltip="$t('buttons:edit')"
            @updateTableData="updateTable"
            :addBtn="true"
            :addBtnText="$t('buttons:add-specific', {specific: $t('common:task')})"
            @clickedAddButton="$refs.taskForm.openDialog()"
            sortBy="incidentDate"
            :sortDesc="true"
            :items-per-page="10"
            @clickedButton1="v => $refs.taskReview.openDialog(v)"
            filterName="task"
            disable-search
          />
        </v-col>
      </v-row>
      <AddTaskDialog ref="taskForm" @closeDialog="loadTasks" />
      <ViewTaskDialog ref="taskReview" @closeDialog="loadTasks" />
    </div>
</div>
</template>

<script>

import DataTablePaginated from '@/modules/core/components/DataTable/DataTablePaginated.vue';
import TaskBoardService from '@/modules/book/services/task-board-service.js';
import ViewTaskDialog from '@/modules/book/views/task/ViewTaskDialog.vue';
import AddTaskDialog from '@/modules/book/views/task/AddTaskDialog.vue';
import UsersService from '@/modules/core/services/users-service';
import NameColumn from '@/modules/book/views/task/name-column';
import InfoService from '@/modules/core/services/info-service';
import DataUtils from "@/modules/core/services/data-utils";
import Utils from '@/modules/core/services/utils';
import Task from "@/modules/book/data/task";
import draggable from 'vuedraggable';

export default {
  name: "IssueBoard",
  components: {
    DataTablePaginated,
    ViewTaskDialog,
    AddTaskDialog,
    draggable
  },
  data() {
    return {
      editable: true,
      kanbanView: true,
      isDragging: false,
      customers: [],
      users: [],
      userId: null,
      search: null,
      currentCompany: {},
      filterCurrentCompany: null,
      invokeUserFn: null,
      invokeProvinceFn: null,
      delayedDragging: false,
      tasks: [],
      myArray: [],
      moveFlag: false,
      currentTaskInfo: {},
      tableCode: [
        'TASK_NEW',
        'OFFER_ADD',
        'OFFER_SIGN',
        'CREATE_ORDER',
        'FINISH_ORDER',
        'INVOICE_ADD',
        'INVOICE_SEND',
        'SUCCESS_TASK'
      ],
      emptyTask: {
        TASK_NEW: [],
        OFFER_ADD: [],
        OFFER_SIGN: [],
        CREATE_ORDER: [],
        FINISH_ORDER: [],
        INVOICE_ADD: [],
        INVOICE_SEND: [],
        SUCCESS_TASK: []
      },
      showFinished: true
    };
  },

  computed: {
    isAdmin() {
      return this.$store.getters["auth/isAdmin"];
    },
    header() {
      this.$t('');
      return NameColumn.getColumns();
    },
    couldBeShown() {
      return this.tasks && this.tasks['TASK_NEW']
    },
    headers() {
      let header = [
        { text: this.$t('common:name'), value: 'name', sortable:true, filter: {
            type: 'text',
            group: 0,
            order: 0
          }
        },
        { text: this.$t('book/issue:common.board-status'), value: 'boardStatusTranslated', sortable:false },
        { text: this.$t('book/issue:add-issue-form.task-date'), value: 'incidentDate', sortable:true },
        { text: this.$t('book/issue:common.appointment-date'), value: 'appointmentDate', sortable:true },
        { text: this.$t('common:elevator'), value: 'facilityName', sortable:true },
        { text: this.$t('book/issue:common.board-status'), value: 'boardStatus', filter: {
            type: 'select',
            enum: 'true',
            group: 0,
            order: 1,
            options: this.getBorderStatusOptions()
          },
          hide: true
        },
        { text: this.$t('book/issue:common.canceled'), value: 'showFinished', hide: true,
          filter: {
            type: 'checkbox',
            group: 0,
            order: 2
          }
        },
        {text: "", value: "controls", sortable: false, align: 'end'},
      ];
      if (this.isAdmin) {
        header.push({
          text: this.$t('common:customer'),
          value: 'customer',
          filter: {
            type: 'select',
            group: 1,
            order: 0,
            preselect: this.$store.state.auth.profile.customer,
            url: 'customer/all-customers',
            invokeFns: {
              updateModel: this.updateCustomerModelEvent
            }
          },
          hide: true
        });

        header.push({ text: this.$t('book/issue:add-issue-form.assigned-manager'),
          value: 'userId',
          default: true,
          hide: true,
          filter: {
            type: 'select',
            group: 1,
            order: 1,
            options: [],
            invokeFns: {
              updateItems: this.updateUserItems,
              setInvokeVariable: this.setInvokeVariable
            }
          }
        });
      } else {
        header.push({ text: this.$t('book/issue:add-issue-form.assigned-manager'),
          value: 'userId',
          default: true,
          hide: true,
          filter: {
            type: 'select',
            group: 1,
            order: 1,
            options: this.users
          }
        });
      }
      return header;
    }
  },
  watch: {
    '$store.state.auth.profile.customer': function() {
      this.setCurrentCompany();
    },
    currentCompany() {
      this.loadTasks();
      this.userId = null;
      this.loadUsers();
    },
    search() {
      this.loadTasks();
    },
    userId() {
      this.loadTasks();
    },
    showFinished() {
      this.loadTasks();
    }
  },
  methods: {
    loadTasks() {
      this.tasks = this.emptyTask;
      if (!this.currentCompany) return;

      if (this.kanbanView) {
        TaskBoardService.loadBoardTasks(this.currentCompany,
            this.search,
            this.userId,
            this.showFinished,
            (response) => {
              this.tasks = response.data;
            },
            () => {
              Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('common:task-list')}));
            }
        );
      } else {
        this.$refs.table.callTableUpdate();
      }
    },
    setCurrentCompany() {
      this.currentCompany = this.$store.state.auth.profile.customer;
      this.loadCustomers();
    },
    movedItem(item) {
      let columnTo = this.getColumnByClassName(item.to._prevClass);
      let task = item.item._underlying_vm_;
      this.changeColumn(columnTo, task);
    },
    getColumnByClassName(className) {
      if (!className || className.length === 0) return;

      let column = '';

      for (let i = 0; i < this.tableCode.length; i++) {
        if (className.indexOf(this.tableCode[i]) > 0) {
          column = this.tableCode[i];
          break;
        }
      }

      return column;
    },
    changeColumn(columnTo, task) {
      task.boardStatus = columnTo;
      TaskBoardService.createOrEditTask(task);
    },
    updateTask(taskId, columCode) {
      TaskBoardService.readTask(
          taskId,
          (response) => {
            let updatedTask = response.data;
            for(let i = 0; i < this.tasks[columCode].length; i++) {
              if (this.tasks[columCode][i].id === updatedTask.id) {
                this.tasks[columCode].splice(i-1, i);
                this.tasks[columCode].push(updatedTask);
              }
            }
          }
      )
    },
    loadCustomers() {
      if (!this.isAdmin) return;

      InfoService.readOptionsByUrl('customer/all-customers',
          (customers) => {
            this.customers = customers;
          },
          (error) => {
            this.$logger.error("Error at fetching all customers: " + error);
            Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('common:customer_plural')}));
          }
      )
    },
    loadUsers() {
      if (!this.currentCompany) return;
      UsersService.loadUsersByCustomer(this.currentCompany,
          (response) => {
            this.users = response.data;
            if (!this.isAdmin) {
              this.users.forEach(user => {
                user.translatedName = user.name;
              })
            }
          }
      );
    },
    updateTable(options, search, filter) {

      if (!search) search = '';

      if (filter.showFinished === 0) {
        filter.showFinished = null
      } else if (filter.showFinished === 1) {
        filter.showFinished = true;
      } else if (filter.showFinished === 2) {
        filter.showFinished = false;
      }

      TaskBoardService.readAllFilteredPaginatedFromAPI(
          options.page - 1,
          options.itemsPerPage,
          search,
          options.sortBy,
          options.sortDesc,
          filter,
          (response) => {
            if (this.$refs.table !== undefined) {
              response.data.content = DataUtils.parseDataToObjectArray(response.data.content, Task);
              response.data.content.forEach((item) => {
                let status = '';
                for(let i = 0; i < this.header.length; i++) {
                  if (this.header[i].code === item.boardStatus) {
                    status = this.header[i].label;
                    break;
                  }
                }
                item.boardStatusTranslated = status;
              })
              this.$refs.table.fillTableData(response.data);
            }
          },
          (error) => {
            this.$refs.table.loading = false;
            Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('common:task-list')}));
            this.$logger.error(error);
          }
      );

    },
    getBorderStatusOptions() {
      let header = this.header;
      let borderStatus = [];

      for (let i = 0; i < header.length; i++) {
        borderStatus.push({
          'id': header[i].code,
          'translatedName': header[i].label
        });
      }

      return borderStatus;
    },
    updateCustomerModelEvent(model) {
      this.filterCurrentCompany = null;
      if (model) {
        this.filterCurrentCompany = model;
      }

      if (typeof this.invokeUserFn === 'function') {
        this.invokeUserFn();
      }

      return model;
    },
    updateUserItems(items) {
      items = [];
      if (!this.filterCurrentCompany) {
        return items;
      }

      UsersService.loadUsersByCustomer(
        this.filterCurrentCompany,
        (response) => {
          response.data.forEach(user => {
            items.push({
              "id": user.id,
              "translatedName": user.name
            });
          })
        },
        () => {
          Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('common:user')}));
        }
      )

      return items;
    },
    setInvokeVariable(invokeFn) {
      this.invokeUserFn = invokeFn;
    }
  },
  mounted() {
    if (window.innerWidth < 600) {
      window.location.replace('/');
    }
    if (this.$route.query.newDialog) {
      this.$refs.taskForm.openDialog();
    }
    if (this.$store.state.auth.profile.customer) {
      this.setCurrentCompany();
    }
  }
}

</script>

<style lang="scss">

.issue-board-row {
  height: 80vh;
  overflow: auto;
  flex-wrap: nowrap;
  column-gap: 0.5%;

  .draggable-col {
    overflow-y: auto;
    overflow-x: auto;
    background-color: #1f75a3;
    border: 1px solid black;
    border-radius: 15px;
    scrollbar-color:#0077ff #b8b8c8;

    .tab-header {
      text-align: center;
      font-size: x-large;
      margin-bottom: 20px;
    }

    .draggable-area {
      height: 50%;

      .v-card {
        margin-bottom: 2px;
      }

      .list-group {
        height: 100%;
      }

      .list-group-item {
        cursor: move;
      }

      .list-group-item i {
        cursor: pointer;
      }
    }
  }

  .draggable-col:last-of-type {
    padding-right: calc(100vw - 100%);
    scrollbar-color:#0077ff #b8b8c8;
  }
}

.actions-panel {
  .task-open {
    min-height: 65% !important;
    width: 100% !important;
  }
  @media (max-width: 599px) {
    .col-sm-12 {
      flex: 0 0 100%;
      max-width: 100%;
    }
  }
}

.v-item-group.theme--light.v-btn-toggle {
  .v-btn {
    margin: 0;
  }
}

</style>
